export default [
  [`Европейские`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Российские`, `44-46`, `46-48`, `48-50`, `50-52`, `52-54`, `54-56`],
  [`В груди, полуобхват (см)`, `49`, `52`, `55`, `58`, `61`, `64`],
  [`Длина (см)`, `68`, `70`, `72`, `74`, `76`, `78`]
];
